<template>
  <v-navigation-drawer app v-model="drawer" class="application-nav">
    <v-img
      :src="'/logo-big.png'"
      :lazy-src="'/logo-big.png'"
      :size="80"
      class="logo"
      contain
    ></v-img>

    <div class="fast-socials"></div>

    <v-divider></v-divider>

    <v-list nav dense mandatory>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        link
        color="primary"
        class="navigation-item"
        @click="redirectTo(item)"
        :active="activeNav && activeNav.url === item.url"
      >
        <template #prepend>
          <v-icon :icon="item.icon"></v-icon>
        </template>
        <v-list-item-content>
          <v-list-item-title> {{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- only if this is separatetor with title -->
    </v-list>
    <template v-slot:append>
      <div class="pa-4">
        <v-btn block @click="() => $router.push('/sign-in')"> Logout </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>


<script>
export default {
  data() {
    return {
      drawer: true,
      items: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          url: "/dashboard",
          check: /dashboard/gi,
        },
        {
          title: "Campaigns",
          icon: "mdi-poll",
          url: "/campaigns",
          check: /campaign.*/gi,
        },
        {
          title: "Inventory",
          icon: "mdi-briefcase-outline",
          url: "/inventory",
          check: /inventor.*/gi,
        },
        {
          title: "My Spent",
          icon: "mdi-currency-usd",
          url: "/my-spent",
          check: /spent/gi,
        },

        {
          title: "Ad Types",
          icon: "mdi-currency-usd",
          url: "/admin/ad-types",
          check: /ad-types/gi,
        },
        {
          title: "Ad Channels",
          icon: "mdi-currency-usd",
          url: "/admin/ad-channels",
          check: /ad-channels/gi,
        },
        {
          title: "Ad Placement Types",
          icon: "mdi-currency-usd",
          url: "/admin/ad-placement-types",
          check: /ad-placement-types/gi,
        },

        {
          title: "Ad Parameters",
          icon: "mdi-currency-usd",
          url: "/admin/ad-parameters",
          check: /ad-parameters/gi,
        },

        {
          title: "Campaigns To Approve",
          icon: "mdi-currency-usd",
          url: "/campaigns-to-review",
          check: /campaigns-to-review/gi,
        },
      ],
      rail: true,
      mini: false,
      activeNav: null,
    };
  },
  created() {
    this.activeNav = this.items.find((item) => {
      return item.check.test(String(this.$route.path));
    });
    console.log("activeNav", this.activeNav);
  },
  methods: {
    redirectTo(item) {
      this.activeNav = item;
      this.$router.push(item.url);
    },
    isActive(item) {
      // return item && false;

      return item.check.test(String(this.$route.path));
    },
  },
};
</script>


<style lang="scss" scoped>
.application-nav {
  // margin-top: 64px;

  @media (max-width: 864px) {
    margin-left: 0px;
    margin-right: 0px;
    width: 40px;
  }

  .first-list {
  }
  max-width: 300px;

  .navigation-item {
    transition: all 0.3;
    &.active {
      background-color: rgba($color: #065ad5, $alpha: 0.3);
    }
    i {
      color: #065ad5;
    }
  }
}

.logo {
}
</style>